import React from 'react';
import { Link } from 'react-router-dom';
import './ui.css';

export const PageHeader: React.FC<{
  breadcrumb?: { label: string; to: string };
  title?: React.ReactNode; description?: React.ReactNode; actions?: React.ReactNode;
}> = ({ breadcrumb, title, description, actions }) => (
  <div className="ui-pageheader">
    {breadcrumb && (
      <div className="ui-pageheader__crumb"><Link to={breadcrumb.to}>← {breadcrumb.label}</Link></div>
    )}
    {(title || actions) && (
      <div className="ui-pageheader__row">
        {title && <h2 className="ui-pageheader__title">{title}</h2>}
        {actions && <div>{actions}</div>}
      </div>
    )}
    {description && <p className="ui-pageheader__desc">{description}</p>}
  </div>
);
